import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";
import DateTimePicker from "app/components/date-time-picker";

/**
 * Proxy Stimulus controller to old style DateTimePicker component
 */
export default class extends Typed(Controller<HTMLInputElement>)
{
    private dateTimePicker: DateTimePicker | null = null;

    public connect(): void {
        this.dateTimePicker = DateTimePicker.getOne(this.element);
    }

    public disconnect(): void {
        this.dateTimePicker?.destroy();
        DateTimePicker.clearInstance(this.element);
    }
}
